/* HabibeeZzz — chat-launcher mag nooit koop- of formulierinformatie afdekken.
   De launcher van de chat-app staat vast in een hoek van het scherm. Bij elke
   scroll/resize meten we zijn werkelijke positie en vergelijken die met de
   beschermde zones (prijs, varianten, voorraad, verzendinfo, koopknop,
   betaalmethoden, contactformulier en belangrijke knoppen). Overlapt hij,
   dan wijkt de launcher tijdelijk; daarbuiten werkt de chat gewoon.
   Heeft de bezoeker de chat zelf geopend, dan blijft hij altijd zichtbaar.
   Alleen presentatie: de instellingen van de chat-app worden niet aangeraakt. */
(function () {
  var PROTECTED = [
    '.product-single__meta .product-block--price',
    '.product-single__meta .hbz-bundle-price',
    '.product-single__meta .variant-wrapper',
    '.product-single__meta .variant-input-wrap',
    '.product-single__meta .uinventory-box',
    '.product-single__meta .shipping-promise',
    '.product-single__meta .add-to-cart',
    '.product-single__meta .u-main-usp',
    '.product-single__form .ultimateTrustBadgesInnerContainer',
    '.product-single__form .shopify-payment-button',
    '#sticky-atc',
    '.contact-form input:not([type="hidden"])',
    '.contact-form textarea',
    '.contact-form select',
    '.contact-form button',
    'main .btn',
    'main .hbz-button',
    'main .hbz-text-link',
    'main .hbz-related-links a',
    '.hbz-footer__btn',
    '.hbz-footer__cta',
    'main button[type="submit"]',
    'main input[type="email"]',
    '.drawer .btn',
    '.cart__checkout'
  ].join(',');
  var PAD = 10;
  var engaged = false;
  var queued = false;

  function chatHost() {
    return document.querySelector('shopify-chat');
  }

  function findActivator(root, depth) {
    if (!root || depth > 4) return null;
    var hit = root.querySelector('[part~="activator"]');
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var deep = findActivator(all[i].shadowRoot, depth + 1);
        if (deep) return deep;
      }
    }
    return null;
  }

  function chatRect(host) {
    var btn = null;
    try { btn = findActivator(host.shadowRoot, 0); } catch (e) { btn = null; }
    if (btn) {
      var r = btn.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return r;
    }
    /* Valt de knop niet te meten: reserveer de standaardhoek linksonder. */
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return { left: 0, right: 140, top: vh - 150, bottom: vh };
  }

  function overlaps(a, b) {
    return a.left < b.right + PAD && a.right > b.left - PAD &&
           a.top < b.bottom + PAD && a.bottom > b.top - PAD;
  }

  function isShown(el) {
    if (el.hidden) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0';
  }

  function apply() {
    queued = false;
    var host = chatHost();
    if (!host) return;
    var yield_ = false;
    if (!engaged) {
      var zone = chatRect(host);
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var nodes = document.querySelectorAll(PROTECTED);
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i].getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) continue;
        if (overlaps(zone, r) && isShown(nodes[i])) { yield_ = true; break; }
      }
    }
    document.body.classList.toggle('hbz-chat-yield', yield_);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('variant:change', schedule);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('shopify-chat')) {
      engaged = true;
      schedule();
    } else {
      setTimeout(schedule, 350); /* accordions, drawers en koopbalk veranderen de layout */
    }
  }, true);

  /* De chat-app laadt asynchroon: de eerste seconden regelmatig opnieuw meten. */
  var ticks = 0;
  var warmup = setInterval(function () {
    schedule();
    if (++ticks > 30) clearInterval(warmup);
  }, 500);

  schedule();
})();
